import { useEffect } from "react";

import { createInProcessOfSignupStorage } from "../utils/auth/createInProcessOfSignupStorage";

const IS_PROCESS_OF_LIFF_SIGN_UP_STORAGE_KEY = "inProcessOfLiffSignup";
const IS_PROCESS_OF_LIFF_SIGN_UP_STORAGE_TIME_KEY = "inProcessOfLiffSignupTime";

// LIFF の起動・アカウント紐付け・新規登録の処理中に立て、AuthProvider の認証状態監視をスキップさせる
const storage = createInProcessOfSignupStorage({
  storageKey: IS_PROCESS_OF_LIFF_SIGN_UP_STORAGE_KEY,
  timeStorageKey: IS_PROCESS_OF_LIFF_SIGN_UP_STORAGE_TIME_KEY,
});

export const setInProcessOfLiffSignup = (inProcess: boolean): void => storage.set(inProcess);

export const clearInProcessOfLiffSignup = (): void => storage.clear();

export const getInProcessOfLiffSignup = (): boolean => storage.get();

// 処理中にリロードされた場合などに残った処理中フラグを、マウント時に解除する
export const useClearInProcessOfLiffSignupOnMount = (): void => {
  useEffect(() => {
    clearInProcessOfLiffSignup();
  }, []);
};
